import React from "react";
import { Formik, Form } from "formik";
import Button from "apollo-react/components/Button";
import Typography from "apollo-react/components/Typography";
import Paper from "apollo-react/components/Paper";
import Grid from "apollo-react/components/Grid";
import Box from "apollo-react/components/Box";
import { FormikTextField, FormikDocumentUpload } from "../FormikComponent";

const CommentsForm = ({ subFormId, onAddComment, onClose, persona,
  hideCancelButton = false, hideTitleSeparator = false,
  buttonAddCommentText = "Add Comment", headerText = "Add Comments" }) => {
  const initialValues = {
    comment: "",
    attachedFiles: []
  };

  const handleAddComment = async (values, { resetForm }) => {
    if (values.comment.trim()) {
      const attachedFile = values.attachedFiles && values.attachedFiles.length > 0 
        ? values.attachedFiles[0] 
        : null;
      
      const fileId = attachedFile?.id || null;
      
      try {
        // Pass both fileId and full file data
        await onAddComment(values.comment, subFormId, fileId, attachedFile); 
        resetForm();
        if (onClose) onClose(); 
      } catch (error) {
        console.error("Error adding comment:", error);
      }
    } else {
      alert("Please enter a comment.");
    }
  };

  return (
    <div>
      <Box sx={{ marginBottom: 4 }}>
        <Typography
          variant="title1"
          component="h2"
          sx={{
            fontWeight: 500,
            marginBottom: hideTitleSeparator ? 0 : 3,
            color: "#333",
            paddingBottom: 1,
            borderBottom: hideTitleSeparator ? "none" : "1px solid #e0e0e0",
          }}
        >
          {headerText}
        </Typography>

        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={handleAddComment}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikTextField
                    name="comment"
                    label="Comment"
                    placeholder="Enter your comment here"
                    multiline
                    fullWidth
                    required
                    minRows={1}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormikDocumentUpload
                    name="attachedFiles"
                    label="Attach File (Optional)"
                    helperText="Upload a file. Supported formats: PDF, Word, Images, Compressed files (ZIP, RAR, 7z, etc.)"
                    accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.csv,.jpg,.jpeg,.png,.gif,.zip,.rar,.7z"
                    multiple={false}
                    maxFiles={1}
                    isAdminUpload={persona !== 'customer'}
                    required={false}
                  />
                </Grid>
              </Grid>

              <Box 
                sx={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  gap: 2,
                  marginTop: 3,
                  paddingTop: 2,
                }}
              >
                {!hideCancelButton && onClose && (
                  <Button 
                    variant="outlined" 
                    color="secondary" 
                    onClick={onClose}
                    sx={{ minWidth: 120 }}
                  >
                    Cancel
                  </Button>
                )}
                
                <Button 
                  variant="contained" 
                  color="primary" 
                  type="submit"
                  sx={{ minWidth: 120 }}
                >
                  {buttonAddCommentText}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

export default CommentsForm;